var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
/** @jsx jsx */


import { memo } from "react";
import { jsx } from "theme-ui";
import { Image } from "theme-ui";
import ACImage from "./ACImage";
import CloudFlareImage from "./CloudFlareImage";

var CDNImage = function CDNImage(props) {
  if (!props.src) {
    return null;
  }

  var origin;

  try {
    origin = new URL(props.src).origin;
  } catch (e) {
    return null;
  }

  if (origin.includes(".acsta.net")) {
    return jsx(ACImage, __assign({}, props));
  }

  if (origin.includes(".webediamovies.pro")) {
    return jsx(CloudFlareImage, __assign({}, props));
  }

  return jsx(Image, {
    alt: props.alt,
    src: props.src,
    width: Array.isArray(props.width) ? Number(props.width[props.width.length - 1]) : props.width,
    height: Array.isArray(props.height) ? Number(props.height[props.height.length - 1]) : props.height
  });
};

export default memo(CDNImage);